'use strict';

module.exports = {
    DAYS_30: 30 * 24 * 60 * 60 * 1000 //30 days in milliseconds
};